<template>
  <div class="invite-info-box">
    <div>
      <h4>社交账号</h4>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="绑定帐号信息"></el-table-column>

        <el-table-column prop="bind" label="状态">
          <template slot-scope="{ row }">
            <el-tag v-if="row.bind" size="small">使用中</el-tag>
            <el-tag v-else size="small" type="warning">未启用</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <el-button v-if="row.bind" size="mini" type="danger" plain @click="handleUnBindThreeUser(row)">解绑
            </el-button>
            <el-button v-else size="mini" type="primary" plain @click="handleBindThreeUser(row)">绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <wecat-login-dialog :visible.sync="dialogVisible" type="bind" :redirect="$route.fullPath"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import wecatLoginDialog from "@/components/third-party/wecat/login-dialog";
import {unbindWechat, unbindWincourse} from "@/api/system/user";

export default {
  components: {
    wecatLoginDialog,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {
    const {avatar, email, id, mobile, nickname, name, username, sex} = this.userInfo;
    this.form = {avatar, email, id, mobile, nickname, name, username, sex};
  },
  computed: {
    ...mapGetters(["userInfo"]),
    tableData() {
      return [
        {
          name: "微信",
          bind: this.userInfo.wechat || false,
        },
        {
          name: "云课时间",
          bind: this.userInfo.wincourse || false,
        },
      ];
    },
  },
  methods: {
    /**
     * 第三方账号绑定
     */
    handleBindThreeUser(record) {
      switch (record.name) {
        case "微信":
          this.handleBindWeCat()
          break

        default:
          console.warn(`${record.name} 账号绑定`, record)
          this.$message.warning("等待开放")
          break
      }
    },
    /**
     * 第三方账号解绑
     */
    handleUnBindThreeUser(record) {
      switch (record.name) {
        case "微信":
          this.handleUnBindWeCat()
          break

        case "云课时间":
          this.handleUnBindWincourse()
          break

        default:
          console.warn(`${record.name} 账号解绑`, record)
          this.$message.warning("等待开放")
          break
      }
    },
    handleBindWeCat() {
      this.dialogVisible = true;
    },
    handleUnBindWeCat() {
      this.$confirm("解绑后将无法使用该第三方帐号登录 实验工坊。", "确定要解绑微信?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            unbindWechat()
                .then(() => {
                  this.$message.success("微信解绑成功");
                })
                .catch((e) => {
                  this.$message.error(e.message);
                });
          })
          .catch(() => {
            // catch
          });
    },
    handleUnBindWincourse(){
      this.$confirm("解绑后将无法使用该第三方帐号登录 实验工坊。", "确定要解绑云课时间?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            unbindWincourse()
                .then(() => {
                  this.$message.success("云课时间解绑成功");
                })
          })
          .catch(() => {
            // catch
          });
    }
  },
};
</script>

<style lang="scss" scoped>
.invite-info-box {
  h4 {
    line-height: 2em;
  }

  h5 {
    line-height: 2em;
    margin-top: 1em;

    & + div {
      margin-top: 0.6em;
    }
  }

  .el-input {
    width: 50%;
    min-width: 200px;
    max-width: 280px;
  }
}
</style>
